export const createLogger = (active: boolean) => {
  return (data: unknown, color?: string) => {
    if (!console || !active) {
      return;
    }
    if (color) {
      console.log(`%c${data}`, `color: ${color}`);
    } else {
      console.log(data);
    }
  };
};
